<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import  userService from './components/service/UserService'
export default {
  name: 'app',
  data(){
    return {
      isLogin: false,
      excludeLoginCheck: ["/play/wasm", "/play/rtc","/mobilePlay","/businessApplyIn"],
      userInfo: { //保存用户信息
        nick: null,
        ulevel: null,
        uid: null,
        portrait: null
      }
    }
  },
  beforeCreate() {
     //判断当前的环境是不是微信环境
     let type = this.$route.query.type;
     console.log(type,"type参数")
     if(type == "wx"){
      console.log("设置之前的token参数值：",localStorage.getItem("mobileToken"))  
      localStorage.setItem("mobileToken","eyJhbGciOiJSUzI1NiIsImtpZCI6IjNlNzk2NDZjNGRiYzQwODM4M2E5ZWVkMDlmMmI4NWFlIn0.eyJqdGkiOiJqTWhEcTF4NlFuemMySzFQZmY2SkVBIiwiaWF0IjoxNzM5NzU5NzY3LCJleHAiOjIyMTQwNTc1NTksIm5iZiI6MTczOTc1OTc2Nywic3ViIjoibG9naW4iLCJhdWQiOiJBdWRpZW5jZSIsInVzZXJOYW1lIjoi56e75Yqo56uv6Ieq5Yqo55m75b2VKOWLv-WIoCkiLCJhcGlLZXlJZCI6Mn0.ks-kjyngFLpuSl17857yJiyBfUk-0N5o0UcWiFUqa4goJI1CxS2y_SE1DXI9zNg5Ks7IEeVmQCg3bmOUfpa3oFHsJo645AlFBOPC6H_o2AT57uOlVCWkW_wUNXqvH9gTZ6f5TpjFrHFuB5qwiKgeXkbY6zC1-xD_zUNMtZEX6XRIC6_GuYSV_GOWvdmwi3CWDIKAbBnJ6f8EfiXkrWdsLVAj1RKDMMz60UP6bZLxYZjNRapS__cju-SxPyvgJsGKp-ONfrJGEPg4CckyzPvexxBnnE6n4mBbU8lkQzMH1XGx7mOft1IxVlNRX7W9gnGI4SwncEdSAr9TWh6Ejp4o3w");
      console.log("设置自动登录token",localStorage.getItem("mobileToken")) 
     }else{
      localStorage.removeItem("mobileToken");
     }


      // 创建 URL 对象，解析原始 URL
      // const parsedUrl = new URL("ws://121.43.228.179/rtp/34020000001110120301_34020000001320000002.live.flv");
      // // 获取当前网页的域名
      // const domain = "test.com";
      // // 修改 URL 的主机部分和端口（如果存在）
      // parsedUrl.hostname = domain;   // 设置新的域名
      // parsedUrl.port = '';           // 清除端口，如果需要使用默认端口（443）的话
      // // 返回修改后的 URL
      // console.log(parsedUrl.href);

  },
  beforeDestroy() {
    localStorage.removeItem("mobileToken");
    console.log("删除自动登录token",localStorage.getItem("mobileToken"))  
  },
  created() {
   // 获取当前页面的路径部分
    var currentUrl = window.location.href;

    // 检查路径中是否包含 'mobilePlay'
    // if (currentUrl.indexOf('mobilePlay') > -1) {
    //     console.log('手机播放页面');

    // }else{
    //    console.log("电脑页面")

    // }


    if (userService.getToken() == null){
      console.log(22222)
      console.log(this.$route.path)
      try {
        if (this.excludeLoginCheck && this.excludeLoginCheck.length > 0) {
          for (let i = 0; i < this.excludeLoginCheck.length; i++) {
            if (this.$route.path.startsWith(this.excludeLoginCheck[i])){
              return;
            }
          }
        }
      }catch (e) {
        console.error(e)
      }
      //如果没有登录状态则跳转到登录页
      this.$router.push('/login');
    }
  },

  mounted(){
    //组件开始挂载时获取用户信息
    // this.getUserInfo();
  },
  methods: {
  },
  components: {}
};
</script>

<style>
html,
body,
#app {
  margin: 0 0;
  background-color: #e9eef3;
  height: 100%;
  overflow: hidden!important;
}
.el-header,
.el-footer {
  /* background-color: #b3c0d1; */
  color: #333;
  text-align: center;
  line-height: 60px;
}
.el-main {
  background-color: #f0f2f5;
  color: #333;
  text-align: center;
  padding-top: 0px !important;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: #F5F5F5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #c8c8c8;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
}
.table-header {
  color: #727272;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/App.vue